import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, finalize, of } from 'rxjs';
import { EquipmentDetails } from 'src/app/models/domain/equipment-details';
import { EquipmentItemDataService } from 'src/app/services';

@Injectable({ providedIn: 'root' })
export class EquipmentBulkDetailsService {
  private readonly errorSubject = new BehaviorSubject<string | undefined>(undefined);
  public readonly error$ = this.errorSubject.asObservable();

  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this.loadingSubject.asObservable();

  private readonly allEquipmentDetailsSubject = new BehaviorSubject<EquipmentDetails[]>([]);
  public readonly allEquipmentDetails$ = this.allEquipmentDetailsSubject.asObservable();

  public constructor(private readonly equipmentDataService: EquipmentItemDataService) {}

  public fetchAllFromDesign(designId: string): void {
    this.loadingSubject.next(true);
    this.errorSubject.next(undefined);

    this.equipmentDataService
      .getEquipmentsByDesignId(designId)
      .pipe(
        catchError(() => {
          this.errorSubject.next('Failed to load equipment list.');

          return of([]); // fallback to empty array
        }),
        finalize(() => {
          this.loadingSubject.next(false);
        })
      )
      .subscribe((details) => {
        this.allEquipmentDetailsSubject.next(details);
      });
  }

  public clear(): void {
    this.allEquipmentDetailsSubject.next([]);
    this.errorSubject.next(undefined);
  }
}
